package com.essntl.features.request.ui.addeditrequest.components

import addedittravelagent.AddEditTravelAgentEvent
import addedittravelagent.AddEditTravelAgentScreen
import addedittravelagent.AddEditTravelAgentState
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.BasicAlertDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.DialogProperties
import com.essntl.features.travelagent.domain.model.TravelAgentModel
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AddEditTravelAgentDialog(
    onDismissRequest: () -> Unit,
    currentTravelAgent: TravelAgentModel? = null,
    state: AddEditTravelAgentState,
    onEvent: (AddEditTravelAgentEvent) -> Unit,
    openDialog: Boolean,
) {

    LaunchedEffect(openDialog) {
        if (openDialog) {
            onEvent(AddEditTravelAgentEvent.ClearTravelAgentState)
            if (currentTravelAgent != null)
                onEvent(AddEditTravelAgentEvent.GetTravelAgent(currentTravelAgent.id))
        }
    }

    if (openDialog) {
        BasicAlertDialog(
            onDismissRequest = onDismissRequest,
            properties = DialogProperties(
                usePlatformDefaultWidth = false,
            ),
            modifier = Modifier.fillMaxSize(0.7f),
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(25.dp)),
            ) {
                Column(
                    horizontalAlignment = Alignment.Start,
                    verticalArrangement = Arrangement.Center,
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(color = Color.White),
                ) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(color = MaterialTheme.esColorScheme.bgPrimary)
                            .padding(vertical = 3.spacing, horizontal = 2.5.spacing),
                    ) {
                        Text(
                            text = if (currentTravelAgent != null) "Edit travel agent" else "Add a travel agent",
                            style = MaterialTheme.esTypography.h3Bold24,
                            color = MaterialTheme.esColorScheme.textPrimary,
                            modifier = Modifier.align(Alignment.CenterStart),
                        )

                        EsSmallOutlineIconButton(
                            onClick = {
                                onDismissRequest()
                            },
                            iconRes = EsIcons.Close,
                            modifier = Modifier.align(Alignment.CenterEnd),
                        )
                    }

                    AddEditTravelAgentScreen(
                        state = state,
                        onEvent = onEvent,
                        dialog = true
                    )
                }
            }
        }
    }
}